import validator from 'validator';

export const validateRequired = (str) => {
  if (!str) {
    return false;
  }
  return str.toString().trim().length;
};

export const validateEmail = (email) => {
  return validator.isEmail(email);
};

export const validatePassword = (password) => {
  return password.toString().trim().length >= 8;
};

export const validateTel = (phoneNumber) => {
  return validator.isMobilePhone(phoneNumber, 'en-US');
};

export const validateAllowedSpecialCharacters = (str) => {
  return validator.isAlphanumeric(str, 'en-US', {
    ignore: ' -_',
  });
};

export const validateEmailField = (email, setError) => {
  if (!validateRequired(email)) {
    setError('Email is required.');
    return false;
  }
  if (!validateEmail(email?.trim())) {
    setError(`${email} is an invalid email.`);
    return false;
  }
  setError(null);
  return true;
};

export const validatePasswordField = (password, setError) => {
  if (!validateRequired(password)) {
    setError('Password is required.');
    return false;
  }
  if (!validatePassword(password)) {
    setError('Invalid password. Password must be at least 8 characters.');
    return false;
  }
  setError(null);
  return true;
};

export const validateTelField = (phoneNumber, setError) => {
  if (!validateRequired(phoneNumber)) {
    setError('Phone Number is required.');
    return false;
  }
  if (!validateTel(phoneNumber)) {
    setError('Invalid phone number.');
    return false;
  }
  setError(null);
  return true;
};

export const validateAgreeToTermsField = (input, setError) => {
  if (!input) {
    setError('You must agree to the Terms of Use.');
    return false;
  }
  setError(null);
  return true;
};

export const validateTextField = (input, setError, validators) => {
  if (
    !validators ||
    !validators.length ||
    !validators.every((validator) => validator.validate && validator.message)
  ) {
    throw new Error('an array of validators must be passed to this function');
  }

  let validated = true;

  validators.forEach((validator) => {
    if (!validator.validate(input)) {
      setError(validator.message);
      validated = false;
    }
  });

  if (validated) {
    setError(null);
  }
  return validated;
};
